import styled from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

// Components
import { Tab, TabButton, TabList } from '@sketch/components'

export const RoleTabsContainer = styled.div`
  position: relative;
`
export const StyledTabList = styled(TabList)`
  padding: 18px 0px 24px 0px; /* stylelint-disable-line scales/space */

  ${breakpoint('base', 'xxs')`
    display: grid;
    grid-template-columns: 1fr 1fr
    justify-items: center;
    text-align: center;
  `}
`

export const StyledTab = styled(Tab)`
  ${breakpoint('base', 'xxs')`
    width: 100%;
  `}

  ${TabButton} {
    font-size: ${({ theme }) => theme.fontSizes.D};

    ${({ theme }) => breakpoint('base', 'md')`
        font-size: ${theme.fontSizes.B};
    `};
  }
`

export const FiltersWrapper = styled.div`
  margin-left: auto;

  ${breakpoint('base', 'xxs')`
    display: flex;
    width: 100%;
    grid-column: 1 / 3;
    margin-left: 0;
    margin-top: 12px;
  `}
`
